<app-warehouse-handling-modal
  [modalIsOpen]="modalWarehouseIsOpen"
  [data]="thisItemOnStock"
  (parentActionOutput)="parentAction($event)"
>
</app-warehouse-handling-modal>

<div
  id="addCard"
  class="card mb-4 stock-card animate__animated animate__backInDown"
  *ngIf="level == 2 || level == 1"
>
  <div class="card-body p-0">
    <ng-container *ngIf="isFastSale; else elseTemplate">
      <div class="row p-0 m-0">
        <div
          class="d-flex justify-content-start align-items-start p-1 col-sm-6 order-sm-6 col-6 order-1"
        >
          <p class="mobile-size">{{ "FastSale" | translate }}</p>
        </div>
        <div
          class="d-flex justify-content-end align-items-start p-1 col-sm-6 order-sm-3 col-6 order-2"
        >
          <button
            type="button"
            class="btn btn-icon btn-outline-primary"
            placement="bottom"
            [routerLink]="['/ElectronicPrescription']"
            ngbTooltip="{{ 'ElectronicPrescription' | translate }}"
          >
            <span class="fa-solid fa-prescription"></span>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-outline-primary ms-1"
            placement="bottom"
            [routerLink]="['/SaleReport']"
            ngbTooltip="{{ 'List' | translate }}"
          >
            <span class="tf-icons bx bx-list-check"></span>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-outline-primary ms-1"
            placement="bottom"
            (click)="print()"
            ngbTooltip="{{ 'Print' | translate }}"
            id="print.id"
          >
            <span class="tf-icons bx bx-printer"></span>
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      
    </ng-template>
    <div class="row">
      <div class="col-12">
        <div class="card-body-box d-flex">
          <div class="prescription-box" [ngClass]="sideBoxClass">
            <div class="row p-1 m-0 drug-list" style="width: 100%">
              <div class="mvc-grid-table">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col">{{ "Row" | translate }}</th>
                        <th scope="col">{{ "GenericCode" | translate }}</th>
                        <th scope="col">{{ "drugBrandName" | translate }}</th>
                        <th scope="col">{{ "ERX" | translate }}</th>
                        <th scope="col">{{ "Number" | translate }}</th>
                        <th scope="col">{{ "Amount" | translate }}</th>
                        <th scope="col">{{ "Insurance" | translate }}</th>
                        <th scope="col">{{ "TotalAmount" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody id="rows">
                      <tr
                        *ngFor="
                          let selectDrug of backendJson.drugList;
                          let i = index
                        "
                      >
                        <td>{{ i + 1 }}</td>
                        <td>{{ selectDrug.genericCode | dataType : "" }}</td>
                        <td>{{ selectDrug.brandName }}</td>
                        <td>{{ selectDrug.erx | dataType : "" }}</td>
                        <td>{{ selectDrug.count }}</td>
                        <td>
                          {{ selectDrug.sellPrice | dataType : "price" }}
                        </td>
                        <td>
                          {{ selectDrug.insurancePrice | dataType : "price" }}
                        </td>
                        <td class="position-relative">
                          <div class="sale-button-box">
                            <span>
                              {{ selectDrug.paidPrice | dataType : "price" }}
                            </span>
                            <div>
                              <button
                                type="button"
                                class="delete-icon-on-table btn btn-icon btn-outline-danger me-1"
                                (click)="remove(i)"
                                ngbTooltip="{{ 'Delete' | translate }}"
                              >
                                <i class="fa-regular fa-trash-can"></i>
                              </button>
                              <button
                                (click)="UidScanner(selectDrug)"
                                class="btn-outline-primary btn btn-icon"
                                ngbTooltip="{{ 'ScanBarcode' | translate }}"
                              >
                                <i class="fa-solid fa-barcode"></i>
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div id="add-box" class="row p-2 mx-1 mb-3 mt-2 add-box-item">
                  <div class="col-12 mb-2">
                    <div class="total-box position-relative">
                      <span
                        class="p-2"
                        [ngbPopover]="stockDetail"
                        #stockDetailLabel="ngbPopover"
                        [autoClose]="'outside'"
                      >
                        {{ "Inventory" | translate }} :
                        {{ editableItem.inventory | number }}
                      </span>
                      <ng-template #stockDetail>
                        <div class="stock-detail">
                          <table class="table table-striped table-size">
                            <thead class="border-none">
                              <tr>
                                <th scope="col">{{ "Stock" | translate }}</th>
                                <th scope="col">{{ "Number" | translate }}</th>
                                <th scope="col">
                                  {{ "expierDate" | translate }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="position-relative"
                                *ngFor="
                                  let item of InventoryList;
                                  let i = index
                                "
                              >
                                <td>{{ item.stockPersianName }}</td>
                                <td>{{ item.count }}</td>
                                <td>{{ item.expierDate | dataType : "" }}</td>
                                <button
                                  class="button-desgin"
                                  (click)="openWarehoseHandelingModal(item)"
                                >
                                  <i
                                    class="fa-solid fa-right-left fix-icon"
                                  ></i>
                                </button>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>

                      <span class="p-2">
                        {{ "PurchasePrice" | translate }} :
                        {{ editableItem.buyPrice | number }}
                        {{ "Rial" | translate }}
                      </span>
                      <span
                        *ngIf="tosale"
                        class="p-2 border-sale position-relative"
                      >
                        {{ "SalesPrice" | translate }} :
                        {{ editableItem.sellPrice | number }}
                        {{ "Rial" | translate }}
                        <button (click)="EditPrice()" class="icon-sale">
                          <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                      </span>

                      <div class="border-sale" *ngIf="!tosale">
                        <input
                          class="p-2 form-control form-set"
                          type="text"
                          [(ngModel)]="backendJsonChange.newPrice"
                          (keyup.Enter)="SaveEditPrice()"
                          placeholder="مبلغ مورد نظر را وارد کنید"
                          mask="separator.0"
            thousandSeparator=","
                        />
                        
                        <button
                          class="icon-sale-position btn btn-icon btn-primary"
                          (click)="SaveEditPrice()"
                        >
                          <i class="fa-solid fa-check"></i>
                        </button>
                        <app-loading-panel
                          *ngIf="changePriceLoading"
                        ></app-loading-panel>
                      </div>
                      <span class="p-2">
                        {{ "SumTotal" | translate }} :
                        {{ editableItem.paidPrice | number }}
                        {{ "Rial" | translate }}
                      </span>
                    </div>
                  </div>
                  <ng-container *ngIf="isFastSale; else pscBox">
                    <div class="col-12 col-xxl-12 col-md-12 mb-3">
                      <div
                        class="edit-form"
                        appClickOutside
                        (clickOutside)="modalIsOpen = false"
                      >
                        <label class="form-label" for="DrugGenricName">
                          {{ "AdvancedSearch" | translate }}
                        </label>
                        <div class="validation-alert-sale-buy">
                          <p>{{ itemValidation.drugNameMessage }}</p>
                        </div>

                        <form [formGroup]="drugSearchForm">
                          <input
                            id="drugBrandName"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            formControlName="drugBrandName"
                            class="form-control Focusable iner-Focusable search-input-box"
                            placeholder="{{
                              'SearchAndScanBarcode' | translate
                            }}"
                            [ngClass]="{
                              'is-invalid':
                                itemValidation.drugNameMessage != '' &&
                                itemValidation.drugNameMessage != null
                            }"
                            [(ngModel)]="editableItem.persianName"
                            (keyup.escape)="modalIsOpen = false"
                          />
                        </form>
                        <app-search-box
                          [data]="searchdata"
                          [urlName]="'DrugSaleSearchBoxTable'"
                          [paging]="searchPaging"
                          *ngIf="modalIsOpen"
                          (parentAction)="parentSearchAction($event)"
                        ></app-search-box>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 col-xxl-4 mb-3">
                      <div class="edit-form row drugcount-status">
                        <div class="validation-alert-count-sale-buy">
                          <p>{{ itemValidation.countMessage }}</p>
                        </div>

                        <div
                          class="col-xxl-3 p-xxl-0 ps-xxl-3 col-md-5 ps-md-3 col-sm-3 ps-sm-3 p-xs-0 col-5 p-2"
                        >
                          <label class="form-label" for="Number">
                            {{ "packageCount" | translate }}
                          </label>
                          <input
                            #count
                            id="packageCount"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            class="form-control input-one Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.packageCount"
                            (keyup)="calcRow()"
                            mask="separator.0"
            thousandSeparator=","
                          />
                           
                        </div>
                        <div
                          class="col-1 p-0 icon-size mt-4 drugpackage-status"
                        >
                          <label class="form-label label-one">
                            <i class="fa-solid fa-xmark"></i>
                          </label>
                        </div>
                        <div
                          class="col-xxl-3 p-xxl-0 col-md-5 p-md-2 col-sm-3 p-xs-0 col-5 p-2"
                        >
                          <label class="form-label" for="Number">
                            {{ "drugPackage" | translate }}
                          </label>
                          <input
                            id="DrugPackage"
                            type="text"
                            appSelectOnFocus
                            (keyup)="calcRow()"
                            autocomplete="off"
                            class="form-control input-one Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.drugPackageCount"
                            mask="separator.0"
            thousandSeparator=","
                            />
                           
                        </div>
                        <div class="col-1 p-0 icon-size mt-4">
                          <label class="form-label label-two col-3">
                            <i class="fa-solid fa-equals"></i>
                          </label>
                        </div>
                        <div
                          class="col-xxl-4 p-xxl-0 pe-xxl-3 col-md-12 px-md-3 col-sm-4 pe-sm-3 p-xs-0 col-12 p-2"
                        >
                          <label class="form-label" for="Number">
                            {{ "Number" | translate }}
                          </label>
                          <input
                            #count
                            id="Number"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            class="form-control Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.count"
                            (ngModelChange)="calcFactor()"
                            mask="separator.0"
            thousandSeparator=","
                          />
                          
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 col-xxl-4 mb-3">
                      <div class="edit-form">
                        <label class="form-label" for="DiscountPercent">
                          {{ "DiscountPercent" | translate }}
                        </label>
                        <input
                          type="text"
                          id="DiscountPercent"
                          class="form-control"
                          (keyup)="calcDiscount(true)"
                          [(ngModel)]="editableItem.discountPercent"
                          #discountPercent
                          mask="separator.0"
            thousandSeparator=","
                        />
                         
                      </div>
                    </div>
                    <div class="col-12 col-md-4 col-xxl-4 mb-3">
                      <div class="edit-form">
                        <label class="form-label" for="Discount">
                          {{ "Discount" | translate }}
                        </label>
                        <input
                          type="text"
                          id="Discount"
                          class="form-control"
                          (keyup)="calcDiscount(false)"
                          [(ngModel)]="editableItem.discount"
                          #Discount
                          mask="separator.0"
            thousandSeparator=","
                        />
                         
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #pscBox>
                    <div class="col-xxl-8 col-12 mb-3">
                      <div
                        class="edit-form"
                        appClickOutside
                        (clickOutside)="modalIsOpen = false"
                      >
                        <label class="form-label" for="DrugGenricName">
                          {{ "AdvancedSearch" | translate }}
                        </label>
                        <div class="validation-alert-sale-buy">
                          <p>{{ itemValidation.drugNameMessage }}</p>
                        </div>

                        <form [formGroup]="drugSearchForm">
                          <input
                            id="drugBrandName"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            formControlName="drugBrandName"
                            class="form-control Focusable iner-Focusable search-input-box"
                            placeholder="{{
                              'SearchAndScanBarcode' | translate
                            }}"
                            [ngClass]="{
                              'is-invalid':
                                itemValidation.drugNameMessage != '' &&
                                itemValidation.drugNameMessage != null
                            }"
                            [(ngModel)]="editableItem.persianName"
                            (keyup.escape)="modalIsOpen = false"
                          />
                        </form>
                        <app-search-box
                          [data]="searchdata"
                          [urlName]="'DrugSaleSearchBoxTable'"
                          [paging]="searchPaging"
                          *ngIf="modalIsOpen"
                          (parentAction)="parentSearchAction($event)"
                        ></app-search-box>
                      </div>
                    </div>
                    <div class="col-12 col-xxl-4 col-xl-12 mb-3">
                      <div class="edit-form row drugcount-status">
                        <div class="validation-alert-count-sale-buy">
                          <p>{{ itemValidation.countMessage }}</p>
                        </div>

                        <div
                          class="p-xxl-0 ps-xxl-0 p-xl-0 ps-xl-3 p-md-0 ps-md-3 p-xs-0 p-2 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-5"
                        >
                          <label class="form-label" for="Number">
                            {{ "packageCount" | translate }}
                          </label>
                          <input
                            #count
                            id="packageCount"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            class="form-control input-one Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.packageCount"
                            (keyup)="calcRow()"
                            mask="separator.0"
            thousandSeparator=","
                          />
                          
                        </div>
                        <div
                          class="col-1 p-0 icon-size mt-4 drugpackage-status"
                        >
                          <label class="form-label label-one">
                            <i class="fa-solid fa-xmark"></i>
                          </label>
                        </div>
                        <div
                          class="p-xxl-0 ps-xxl-0 p-xl-0 p-md-0 p-xs-0 p-2 col-xxl-3 col-xl-3 col-lg-4 col-md-3 col-5"
                        >
                          <label class="form-label" for="Number">
                            {{ "drugPackage" | translate }}
                          </label>
                          <input
                            id="DrugPackage"
                            type="text"
                            appSelectOnFocus
                            (keyup)="calcRow()"
                            autocomplete="off"
                            class="form-control input-one Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.drugPackageCount"
                            mask="separator.0"
            thousandSeparator=","
                          />
                          
                        </div>
                        <div class="col-1 p-0 icon-size mt-4">
                          <label class="form-label label-two col-3">
                            <i class="fa-solid fa-equals"></i>
                          </label>
                        </div>
                        <div
                          class="p-xxl-0 ps-xxl-0 pe-xxl-3 p-xl-0 pe-md-3 p-md-0 p-xs-0 p-2 col-xxl-3 col-xl-4 col-lg-3 col-md-3 col-12"
                        >
                          <label class="form-label" for="Number">
                            {{ "Number" | translate }}
                          </label>
                          <input
                            #count
                            id="Number"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            class="form-control Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                              itemValidation.countMessage != '' &&
                              itemValidation.countMessage != null
                            }"
                            [(ngModel)]="editableItem.count"
                            (ngModelChange)="calcFactor()"
                            mask="separator.0"
            thousandSeparator=","
                          />
                           
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 mb-3"
                      [ngClass]="
                        backendJson.insurance == 'OTC' ||
                        backendJson.insurance == 'PSC'
                          ? 'col-xl-6 col-xxl-6'
                          : 'col-xl-4 col-xxl-3'
                      "
                    >
                      <div class="edit-form">
                        <label class="form-label" for="DiscountPercent">
                          {{ "DiscountPercent" | translate }}
                        </label>
                        <input
                          type="text"
                          id="DiscountPercent"
                          class="form-control"
                          (keyup)="calcDiscount(true)"
                          [(ngModel)]="editableItem.discountPercent"
                          #discountPercent
                          mask="separator.0"
            thousandSeparator=","
                        />
                       
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 mb-3"
                      [ngClass]="
                        backendJson.insurance == 'OTC' ||
                        backendJson.insurance == 'PSC'
                          ? 'col-xl-6 col-xxl-6'
                          : 'col-xl-4 col-xxl-3'
                      "
                    >
                      <div class="edit-form">
                        <label class="form-label" for="Discount">
                          {{ "Discount" | translate }}
                        </label>
                        <input
                          type="text"
                          id="Discount"
                          class="form-control"
                          (keyup)="calcDiscount(false)"
                          [(ngModel)]="editableItem.discount"
                          #Discount
                          mask="separator.0"
            thousandSeparator=","
                        />
                         
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 col-xl-4 col-xxl-3 mb-3"
                      *ngIf="
                        backendJson.insurance != 'OTC' &&
                        backendJson.insurance != 'PSC'
                      "
                    >
                      <div class="edit-form">
                        <label class="form-label" for="InsurancePrice">
                          {{ "InsurancePrice" | translate }}
                        </label>
                        <input
                          type="text"
                          id="InsurancePrice"
                          class="form-control"
                          (keyup)="calcFactor()"
                          [(ngModel)]="editableItem.insurancePrice"
                          #Discount
                          mask="separator.0"
            thousandSeparator=","
                        />
                          
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6 col-xl-4 col-xxl-3 mb-3"
                      *ngIf="
                        backendJson.insurance != 'OTC' &&
                        backendJson.insurance != 'PSC'
                      "
                    >
                      <div class="edit-form">
                        <label class="form-label" for="ShareCurrencyPrice">
                          {{ "ShareCurrencyPrice" | translate }}
                        </label>
                        <input
                          type="text"
                          id="ShareCurrencyPrice"
                          class="form-control"
                          (keyup)="calcFactor()"
                          [(ngModel)]="editableItem.shareCurrencyPrice"
                          #Discount
                          mask="separator.0"
            thousandSeparator=","
                        />
                         
                      </div>
                    </div>
                  </ng-template>
                  <div class="col-12">
                    <hr />
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-primary"
                      id="save-button"
                      (click)="confirmNewItem()"
                    >
                      <i class="far fa-save"></i>
                      {{ "Save" | translate }}
                    </button>
                    <button
                      type="button"
                      id="clear-button"
                      class="btn btn-light ms-2"
                      (click)="clearNewItem()"
                    >
                      <i class="fas fa-eraser"></i>
                      {{ "Clear" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <app-loading-panel *ngIf="loading"></app-loading-panel>
          </div>
          <div
            class="side-box-body d-flex align-items-center"
            [ngClass]="sideBoxClass"
          >
            <div class="side-box position-relative">
              <div class="side-box-close-button-box" [ngClass]="sideBoxClass">
                <button type="button" (click)="changeSideBoxState()">
                  <i
                    class="bx"
                    [ngClass]="{
                      'bxs-chevron-left':
                        sideBoxClass == 'side-box-open' ||
                        sideBoxClass == 'side-box-try-open',
                      'bxs-chevron-right':
                        sideBoxClass == 'side-box-close' ||
                        sideBoxClass == 'side-box-try-close'
                    }"
                  ></i>
                </button>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="side-box-header py-1">
                    <h6 class="m-0">
                      {{ "CustomerCheckout" | translate }}
                    </h6>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumItems" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.elementPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="side-box-key-value mx-2">
                    <label for="technicalRight">
                      {{ "technicalRight" | translate }}
                    </label>
                    <div class="input-currency-box">
                      <input
                        id="insuranceTechnicalRight"
                        type="text"
                        class="form-control"
                        [(ngModel)]="backendJson.technicalRight"
                        (keyup)="allFactor()"
                        mask="separator.0"
            thousandSeparator=","
                      />
                        
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr class="my-1" />
                </div>
                <div class="col-12 mb-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumPsc" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.prescriptionPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
                <div
                  class="col-12 mt-2"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "InsuranceShare" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.insurancePrice | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="insuranceTechnicalRight">
                      {{ "insuranceTechnicalRight" | translate }}
                    </label>
                    <div class="input-currency-box">
                      <input
                        id="insuranceTechnicalRight"
                        type="text"
                        class="form-control"
                        [(ngModel)]="backendJson.insuranceTechnicalRight"
                        (keyup)="allFactor()"
                        mask="separator.0"
            thousandSeparator=","
                      />
                    
                      <p>ریال</p>
                    </div>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "ShareCurrencyPrice" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.shareCurrencyPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div
                  class="col-12"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <hr class="my-1" />
                </div>
                <div
                  class="col-12 mb-2"
                  *ngIf="
                    backendJson.insurance != 'OTC' &&
                    backendJson.insurance != 'PSC'
                  "
                >
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "SumInsurance" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.totalInsurance | dataType : "price" }}
                    </p>
                  </div>
                </div>

                <div class="col-12 my-2">
                  <div class="side-box-key-value mx-2">
                    <label for="">
                      {{ "Payable" | translate }}
                    </label>
                    <p class="m-0">
                      {{ backendJson.paidPrice | dataType : "price" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ScanBarcodeModal let-modal class="modal modal-top fade">
  <app-scan-barcode-modal
    [itemCount]="selectValue.packageCount"
    [barcodeList]="selectValue.drugUIds"
    (parentActionOutput)="parentAction($event)"
  ></app-scan-barcode-modal>
</ng-template>

<app-sale-print-factor
  [modalIsOpen]="receptModalIsOpen"
  [recept]="recept"
  (parentAction)="parentAction($event)"
></app-sale-print-factor>
